import _ from "lodash";

export default class SelectedDates {
	/**
	 * Loops over dates, if false is called the loop terminates
	 * @param dates
	 * @param callback
	 */
	static loop(dates, callback) {
		if(_.isPlainObject(dates)) {
			_.each(dates, (singleDate) => {
				return callback(singleDate);
			});
		} else {
			callback(dates);
		}
	}
}